import {useEffect, useState} from "react";
import Logout from "../components/auth/Logout";
import Center from "../components/utils/Center";
import {Button, Stack, TextField} from "@mui/material";
import axios from 'axios';
import {useNavigate} from "react-router-dom";

interface Props {
}

const Home = ({}: Props) => {
  const [channelIds, setChannelIds] = useState<string[]>([]);
  const [channelSearchKey, setChannelSearchKey] = useState<string>('');
  const [source, setSource] = useState<string>('');
  let navigate = useNavigate();

  useEffect(() => {
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function addChannels() {
    channelIds.forEach(channelId => {
      axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/addChannel?channelId=${channelId.trim()}&source=${source.trim()}`)
        .then((response) => {
        })
        .catch((error) => {
          console.log(error);
        });
    });
  }

  function searchForChannels() {
    let aECount: number = 0;
    let aNCount: number = 0;
    axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/searchForChannels?searchKeyword=${channelSearchKey.trim()}`)
      .then((response) => {
        let existingCount: number = 0;
        let searchChannels: [] = response.data.searchChannels;
        console.log(searchChannels)
        const channelList: string[] = [];
        searchChannels.forEach((value: any) => {
          if (channelList.includes(value.channelId)) {
            existingCount = existingCount + 1;
          } else {
            channelList.push(value.channelId);
          }
        });
        console.log('Found ' + channelList.length + ' unique channels for ' + channelSearchKey.trim());
        channelList.forEach((channelId:string)  => {
          axios.get(`https://us-central1-influencer-database-c0208.cloudfunctions.net/api/addChannel?channelId=${channelId.trim()}&source=${channelSearchKey.trim().replaceAll(' ', '_')}`)
            .then((response) => {
              if (response.data === 'AE') {
                aECount++;
              } else {
                aNCount++;
              }
            })
            .catch((error) => {
              console.log(error);
            }).then(value => {
            console.log(`Already Exists: ${aECount}`);
            console.log(`New Added: ${aNCount}`);
          });
        });
      }).catch((error) => {
        console.log(error);
      });
  }

  function goToSearch() {
    navigate('/search');
  }

  const handleAddChannelIdsChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setChannelIds(typeof value === 'string' ? value.split(',') : value,)
  }

  const handleSearchChannels = (event: any) => {
    const {
      target: {value},
    } = event;
    setChannelSearchKey(value)
  }

  const handleSourceChange = (event: any) => {
    const {
      target: {value},
    } = event;
    setSource(value)
  }

  return (
    <Center>
      <Stack width={360} spacing={2} direction="column">
        <Stack spacing={2} direction="row">
          <TextField id="searchChannels" label="Search Keyword" variant="outlined"
                     onChange={handleSearchChannels}/>
          <Button variant="contained" onClick={searchForChannels}>
            Search
          </Button>
        </Stack>

        <TextField id="channelSource" label="Source" variant="outlined" onChange={handleSourceChange}/>
        <Stack spacing={2} direction="row">
          <TextField multiline id="addChannelIds" label="Channel IDs" variant="outlined"
                     onChange={handleAddChannelIdsChange}/>
          <Button variant="contained"
                  onClick={addChannels}>
            Add Channel
          </Button>
        </Stack>
        <Stack spacing={2} direction="row">
          <Button variant="contained"
                  onClick={goToSearch}>
            Go to Search
          </Button>
          <Logout/>
        </Stack>
      </Stack>
    </Center>
  );
};

export default Home;
